/**
 * Sailing Selection
 */

(function SailingSelection($, Adzuki)
{
	var sailing_selection = {};

	// the css classes that we will be looking for to do stuff
	sailing_selection.parent_css  = 'sailing-selection';
	sailing_selection.cruise_css  = 'sailing-selection-cruise-line';
	sailing_selection.ship_css    = 'sailing-selection-ships';
	sailing_selection.sailing_css = 'sailing-selection-sailings';

	// the name of the attribute (data-pre-selected) that we use to pre-populate the drop-down menus when necessary
	sailing_selection.data_attr   = 'pre-selected';

	/**
	 * Get list of cruise lines via ajax and then call function to populate drop-downs
	 * @param  jquery Object $el The element where the cruise lines are listed
	 */
	sailing_selection.getCruiseLines = function getCruiseLines($el)
	{
		var $parent          = $('.' + sailing_selection.parent_css),
		    only_econnect    = $parent.data('only-econnect') || 0,
		    only_display_fac = $parent.data('display-fac') || 0,
		    group_by_type    = $parent.data('group-by-type') || 0,
			only_seg         = $parent.data('only-seg') || 0;

		Adzuki.Ajax.get('/CruiseSearch/getCruiseLines/' + only_econnect + '/' + only_display_fac + '/' + group_by_type + '/' + only_seg).then(function success(data) {
			var cruise_line_list  = '',
			    $cruise_lines     = $('.' + sailing_selection.cruise_css);

			if (group_by_type) {
				cruise_line_list = data;
			} else {
				cruise_line_list = Adzuki.Sort.alphabeticValue(data);
			}

			$cruise_lines.each(function iti( index, value ) {
				var $el = $(this);
				sailing_selection.populateCruiseLines($el, cruise_line_list, group_by_type);
			});
		});
	};

	/**
	 * Fill in all cruise line drop-down options on the page
	 * @param  jQuery Object $el   the element
	 * @param  object        data  the options for the cruise line drop-down that were returned via ajax get
	 */
	sailing_selection.populateCruiseLines = function populateCruiseLines($el, data, grouped_by_type)
	{
		var pre_selected_val = $el.data(sailing_selection.data_attr);

		$el.empty();
		$el.append($('<option>').text('Choose Cruise Line').attr('value', ''));

		if (grouped_by_type) {
			$.each(data, function parseCruiseLines(oKey, oValues) {
				var $optgroup        = $('<optgroup label="' + oKey + '">'),
				    cruise_line_list = Adzuki.Sort.alphabeticValue(oValues);

				$.each(cruise_line_list, function appendCruiseLines(sKey, sValue) {
					$optgroup.append($('<option>').text(sValue.value).attr('value', sValue.key));
				});

				$el.append($optgroup);
			});
		} else {
			$.each(data, function parseCruiseLines(sKey, sValue) {
				$el.append($('<option>').text(sValue.value).attr('value', sValue.key));
			});
		}

		// the cruise line is pre-populated, get ship options
		if (pre_selected_val > 0) {
			$el.val(pre_selected_val);
			sailing_selection.getShips($el).then(sailing_selection.removePreSelection($el));
		}
	};

	/**
	 * Populate ships drop-down based on cruise line id selected from the closest cruise line drop-down.
	 * @param  jQuery Object $cruise_line_element The cruise line element
	 */
	sailing_selection.getShips = function getShips($cruise_line_element)
	{
		var sortedData,
		    cruiseLineId     = $cruise_line_element.val(),
		    $parent          = $cruise_line_element.closest('.' + sailing_selection.parent_css),
		    $shipDD          = $parent.find('.' + sailing_selection.ship_css),
		    $sailingDD       = $parent.find('.' + sailing_selection.sailing_css),
		    pre_selected_val = $shipDD.data(sailing_selection.data_attr),
			only_seg         = $parent.data('only-seg') || 0,
		    url              = '/CruiseSearch/getShips/' + cruiseLineId + '/list/' + only_seg;
		    // only_active      = $parent.data('only-active');

		$shipDD.empty();
		$shipDD.append($('<option>').text('Choose Ship').attr('value', ''));
		$sailingDD.empty();
		$sailingDD.append($('<option>').text('Choose Sailing').attr('value', ''));

		// If we ever want to only list ships with active upcoming sailings, uncomment these lines and the only_active var declaration above
		// if (only_active > 0) {
		// 	url = '/CruiseSearch/getActiveShips/' + cruiseLineId;
		// }

		Adzuki.Ajax.get(url).then(function success(data) {
			sortedData = Adzuki.Sort.alphabeticValue(data);

			// $shipDD.append($('<option>').text('2Choose Ship').attr('value', ''));

			$.each(sortedData, function parseShips(sKey, sValue) {
				$shipDD.append($('<option>').text(sValue.value).attr('value', sValue.key));
			});

			// the ship is pre-populated, get sailing options
			if (pre_selected_val > 0) {
				$shipDD.val(pre_selected_val);
				sailing_selection.getSailings($shipDD);
				sailing_selection.removePreSelection($shipDD);
			}
		});

		$shipDD.focus();
	};

	/**
	 * Populate the sailings drop down based on the ship selected
	 * @param  jQuery Object $shipDD The ships element
	 */
	sailing_selection.getSailings = function getSailings($shipDD)
	{
		var keyParts,
		    shipId           = $shipDD.val(),
		    $parent          = $shipDD.closest('.' + sailing_selection.parent_css),
		    passed_sailings  = $parent.data('include-passed'),
		    only_active      = $parent.data('only-active'),
		    include_canceled = $parent.data('include-canceled'),
		    $sailingDD       = $parent.find('.' + sailing_selection.sailing_css),
		    pre_selected_val = $sailingDD.data(sailing_selection.data_attr),
			only_seg         = $parent.data('only-seg') || 0,
		    url              = '/CruiseSearch/getSailings/' + shipId + '/' + passed_sailings + '/' + only_active + '/' + include_canceled + '/0/' + only_seg;

		$sailingDD.empty();

		Adzuki.Ajax.get(url).then(function success(data) {
			if (shipId === "") {
				$sailingDD.append($('<option>').text('Choose Sailing').attr('value', ''));
			} else {
				$sailingDD.append($('<option>').text('Choose Sailing').attr('value', ''));

				$.each(data, function parseSailings(key, value) {
					keyParts = key.split("|");

					$sailingDD.append($('<option>').text(value).attr('value', keyParts[1]));
				});

				// the itinerary is pre-populated
				if (pre_selected_val > 0) {
					$sailingDD.val(pre_selected_val).trigger('ss.itinerary-prepopulated');
					sailing_selection.removePreSelection($sailingDD);
				}
			}
		});

		$sailingDD.focus();
	};

	sailing_selection.removePreSelection = function removePreSelection($element)
	{
		$element.data(sailing_selection.data_attr, 0);
	};


	sailing_selection.init = function init()
	{
		if ($('.' + sailing_selection.parent_css).length) {
			sailing_selection.getCruiseLines();

			$('.' + sailing_selection.cruise_css).on('change', function cruiseChange() {
				var $el = $(this);
				sailing_selection.getShips($el);
			});

			$('.' + sailing_selection.ship_css).on('change', function shipChange() {
				var $el = $(this);
				sailing_selection.getSailings($el);
			});
		}
	};

	$(document).ready(function documentReady()
	{
		sailing_selection.init();
	});

	Adzuki.SailingSelection = sailing_selection;

}(jQuery, window.Adzuki || {}));
